import React, { useState } from 'react';
import { useAppointmentStateUnsafe } from '../../../context/Appointment/appointment';
import { GMAppointmentName } from '../../../controls/AppointmentName';
import { useDisplayLocalizedVehicle } from '../../../helpers/displayVehicle';
import { formatAsCurrency } from '../../../helpers/Number';
import { useKioskState } from '../../../context/Kiosk/kiosk';
import css from './WorldPayBanner.module.scss';
import { useLocalization } from '../../../context/Localization/localization';

interface ComponentProps {
    intructionText: string;
}

export const WorldPayBanner: React.FC<ComponentProps> = ({ intructionText }) => {
    const appointment = useAppointmentStateUnsafe();
    const Localization = useLocalization();
    const displayLocalizedVehicle = useDisplayLocalizedVehicle();
    const {
        templateFolder,
        dealer: { country },
    } = useKioskState();
    const [showDealerLogo, setShowDealerLogo] = useState<boolean>(!!templateFolder);

    return (
        <div>
            {appointment ?
                <div className={css.banner}>
                    {showDealerLogo ?
                        <div>
                            <img
                                className={css.dealerLogo}
                                src={`${process.env.REACT_APP_ASSETS_URL}/dealer/${templateFolder}/img/dealerlogo.png`}
                                alt={'Dealer Logo'}
                                onError={() => setShowDealerLogo(false)}
                            />
                        </div> : null
                    }
                    <div className={css.appointment}>
                        <div>
                            <GMAppointmentName fullName lastFirst={false} />
                        </div>
                        <div>
                            {Localization.formatString(Localization.RO, appointment.roNumber ?? '')}
                        </div>
                        <div>
                            {displayLocalizedVehicle(appointment)}
                        </div>
                    </div>
                    <div className={css.price}>
                        {formatAsCurrency(appointment.serviceTotal, false, country)}
                    </div>
                </div> : null
            }
            <h4 className={css.instructions}>
                {intructionText}
            </h4>
        </div>
    );
};